import $ from 'jquery'

$(document).on('turbo:load', onLoad)
$(document).on('turbo:frame-load', onLoad)

function onLoad(e) {
  $('.alert-success').delay(1000).fadeOut(2000)
  $('.alert-danger').delay(1000)
}
